// import { IStatisticState } from './types';

const initialState = {
  actionProcessing: false,
  statistic: {
    balanceStatistic: {
      balanceOfUser: null,
      balanceOfCashier: null,
      balanceOfAdmin: null,
    },
    totalStatistic: {
      usersCount: 0,
      activeUsers: 0,
      totalBets: 0,
      totalWins: 0,
      totalGGR: 0,
      totalMargin: 0,
    },
    totalMetricStatistic: {
      metricName: null,
      totalDiff: 0,
      diffPercent: 0,
      currentPeriod: {
        total: 0,
        totalByDate: [],
      },
      previousPeriod: {
        total: 0,
        totalByDate: [],
      },
    },
    ggrRanking: [],
  },
  balanceStatistic: [],
};

export default initialState;
